import axios from 'axios'
import Qs from 'qs'

// create an axios instance
const service = axios.create({ timeout: 1000 * 60 * 3 });

service.interceptors.request.use(
  config => {
    if(!config.headers['Content-Type'] && config.method.toLowerCase() === 'post' && config.data) {
      config.data = Qs.stringify(config.data)
    }
    return config
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    response.config['loading'] && response.config['toastInstance'].clear()
    const res = response.data;
    if (response.config['exportFile']) {
      // 文件导出
      if (res) {
        return {
          data: res,
          fileName: response['headers']['file-describe']
        }
      } else {
        !response.config['noTip'];
        console.log('err', res);
        return Promise.reject(res.message);
      }
    }
    if (res.code !== 0) {
      !response.config['noTip'];
      console.log('err', res.message || 'Error');
      return Promise.reject(res);
    } else {
      return res
    }
  },
  error => {
    console.log('err', error);
    return Promise.reject(error);
  }
);

export default service